import React, { useState, useEffect } from "react";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrashAlt } from "react-icons/fa";
import "../../Styles/yellocalfcss/UpcomingInvoices.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import GenerateArrearInvoice from "./SelectStudent";
import ScaleLoader from "react-spinners/ScaleLoader";

const UpcomingInvoices = () => {
  const navigate = useNavigate();
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");

  // --- State Management ---
  const [invoices, setInvoices] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [generateInvoice, setGenerateInvoice] = useState(false);
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState({
    student: "",
    academicYear: "",
  });

  // --- API Integration ---
  useEffect(() => {
    loadBillDetails();
  }, []);

  const loadBillDetails = async () => {
    setIsLoading(true);
    try {
      const response = await simplePostCall(
        ApiConfig.upcomingFeeInvoice,
        JSON.stringify({
          customer_id: Number(localStorage.getItem("customer_id")),
          api_key: localStorage.getItem("api_key"),
          user_id: Number(localStorage.getItem("user_id")),
          language: "en",
          id: "pending",
        }),
      );

      if (response?.result) {
        // 1. Set Invoices
        setInvoices(response.data || []);

        // 2. Set Dropdown Data
        setStudentList(response.student_data || []);
        setAcademicYears(response.academic_year || []);

        // 3. Set Settings (Toggle)
        if (response.settings?.length > 0) {
          setGenerateInvoice(
            response.settings[0].settings_generate_fee_invoice === 1,
          );
        }
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // --- Helpers ---
  const handleClear = () => {
    setFilters({ student: "", academicYear: "" });
    setMessage("Filters cleared!");
  };

  const handleGenerateInvoiceToggle = () => {
    setGenerateInvoice(!generateInvoice);
    // Add API call here to update settings if required
  };

  // Helper to remove "" for calculations
  const parseCurrency = (value) =>
    Number(value?.replace(/[^0-9.-]+/g, "")) || 0;

  // --- Filtering Logic ---
  const filteredData = invoices.filter((item) => {
    return (
      (filters.student === "" || item.student === filters.student) &&
      (filters.academicYear === "" ||
        item.fee_invoice_accademic_year === filters.academicYear)
    );
  });

  // if (isLoading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
  //       <Spinner animation="border" variant="warning" />
  //     </div>
  //   );
  // }

  return (
    <div className="upcoming-invoices-primary-wrapper mt-3">
      <Container fluid className="upcoming-invoices-container-wrapper">
        <div className="upcoming-invoices-header-section d-flex p-2">
          <h1 className="upcoming-invoices-title-label">
            Upcoming Fee Invoices
          </h1>
          <div className="upcoming-invoices-controls-section">
            <Button
              className="upcoming-invoices-collect-btn"
              onClick={() => navigate("/collectpayment")}
            >
              Collect Fee
            </Button>
            <Button
              className="upcoming-invoices-collect-btn"
              onClick={() => navigate("/selectstudent")}
            >
              Add Arrears
            </Button>
           
            <Button
              className="upcoming-invoices-special-btn"
              onClick={() => navigate("/specialfee")}
            >
              Special Fees
            </Button>

             <Button
              className="upcoming-invoices-select-btn"
              onClick={() => navigate("/genrateinvoice")}
            >
              Generate Invoice
            </Button>

            <div className="upcoming-invoices-toggle-section">
              <span className="upcoming-invoices-toggle-label">
                Generate Invoice:
              </span>
              <div className="upcoming-invoices-switch-wrapper">
                <Form.Check
                  type="switch"
                  id="upcoming-invoices-switch"
                  checked={generateInvoice}
                  onChange={handleGenerateInvoiceToggle}
                />
                <span
                  className={`upcoming-invoices-switch-status {generateInvoice ? "upcoming-invoices-status-yes" : "upcoming-invoices-status-no"}`}
                >
                  {generateInvoice ? "YES" : "NO"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* --- Filters Section --- */}
        <div className="upcoming-invoices-filter-section">
          <div
            className="upcoming-invoices-filter-controls"
            style={{ marginTop: "3px" }}
          >
            <Form.Select
              className="upcoming-invoices-select-student form-control-sm"
              value={filters.student}
              onChange={(e) =>
                setFilters({ ...filters, student: e.target.value })
              }
            >
              <option value="">Select Student</option>
              {studentList.map((s) => (
                <option key={s.student_id} value={s.student_name.split("(")[0]}>
                  {s.student_name}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              className="upcoming-invoices-select-year form-control-sm"
              value={filters.academicYear}
              onChange={(e) =>
                setFilters({ ...filters, academicYear: e.target.value })
              }
            >
              <option value="">Select Academic Year</option>
              {academicYears.map((y) => (
                <option key={y.academic_year_id} value={y.academic_year_id}>
                  {y.academic_year_name}
                </option>
              ))}
            </Form.Select>

            <Button
              onClick={handleClear}
              className="upcoming-invoices-clear-button"
            >
              Clear
            </Button>
          </div>
        </div>

        {/* --- Table Section --- */}
        <div className="upcoming-invoices-table-header-row">
          <div
            className="upcoming-invoices-grid-layout"
            style={{ textAlign: "center" }}
          >
            <div className="upcoming-invoices-header-cell">Sr.No</div>
            <div className="upcoming-invoices-header-cell">Invoice ID</div>
            <div className="upcoming-invoices-header-cell">Student</div>
            <div className="upcoming-invoices-header-cell">Academic Year</div>
            <div className="upcoming-invoices-header-cell">Demand Date</div>
            <div className="upcoming-invoices-header-cell">Due Date</div>
            <div className="upcoming-invoices-header-cell">Amount Total</div>
            <div className="upcoming-invoices-header-cell">Amount Paid</div>
            <div className="upcoming-invoices-header-cell">Balance</div>
            <div className="upcoming-invoices-header-cell">Action</div>
          </div>
        </div>
        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "10vh" }} //here loader height defined
          >
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : (
          <div
            className="upcoming-invoices-data-rows-wrapper"
            style={{ textAlign: "center" }}
          >
            {filteredData.map((item, index) => {
              const total = parseCurrency(item.fee_invoice_amount_total);
              const paid = parseCurrency(item.fee_invoice_total_amount_paid);
              const balance = total - paid;

              return (
                <div
                  key={item.fee_invoice_id}
                  className="upcoming-invoices-row-card"
                >
                  <div className="upcoming-invoices-grid-layout">
                    <div className="upcoming-invoices-data-cell">
                      {index + 1}
                    </div>
                    <div className="upcoming-invoices-data-cell">
                      {item.fee_invoice_id}
                    </div>
                    <div className="upcoming-invoices-data-cell">
                      {item.student}
                    </div>
                    <div className="upcoming-invoices-data-cell">
                      {item.academic_year_name}
                    </div>
                    <div className="upcoming-invoices-data-cell">
                      {item.fee_invoice_demand_date}
                    </div>
                    <div
                      className="upcoming-invoices-data-cell"
                      style={{ marginLeft: "22px" }}
                    >
                      {item.fee_invoice_due_date}
                    </div>
                    <div
                      className="upcoming-invoices-data-cell"
                      style={{ marginLeft: "20px" }}
                    >
                      {customer_currency}{item.fee_invoice_amount_total}
                    </div>
                    <div
                      className="upcoming-invoices-data-cell"
                      style={{ marginLeft: "20px" }}
                    >
                      {customer_currency}{item.fee_invoice_total_amount_paid}
                    </div>
                    <div
                      className="upcoming-invoices-data-cell"
                      style={{ marginLeft: "22px" }}
                    >
                      {customer_currency}{balance.toLocaleString()}
                    </div>
                    <div
                      className="upcoming-invoices-data-cell upcoming-invoices-action-cell"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        marginLeft: "25px",
                      }}
                    >
                      <button
                        className="upcoming-invoices-action-icon"
                        onClick={() =>
                          navigate(`/viewinvoice/${item.fee_invoice_id}`)
                        }
                      >
                        <FaEye />
                      </button>
                      {/* <button className="upcoming-invoices-action-icon" onClick={() => navigate(`/editinvoice/{item.fee_invoice_id}`)}><FaEdit /></button> */}
                      {/* <button className="upcoming-invoices-action-icon text-danger"><FaTrashAlt /></button> */}
                    </div>
                  </div>
                </div>
              );
            })}
            {filteredData.length === 0 && (
              <div className="p-4 text-center">No pending invoices found.</div>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default UpcomingInvoices;
